var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var SamplesList = /** @class */ (function (_super) {
    __extends(SamplesList, _super);
    function SamplesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Име', key: 'bg_name', filter: false, sort: false },
            { name: 'Опаковка', key: 'packaging', filter: false, sort: false },
            { name: 'Статус', key: 'status', filter: false, sort: false },
        ];
        _this.editProduct = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editSample.path.replace(':sampleId', selectedId));
            }
        };
        _this.deleteRelatedCollection = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                _this.api.deleteSample(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Записът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        _this.onPage = function (event) {
            _this.props.changePage(event.page + 1);
        };
        return _this;
    }
    SamplesList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, lazy: true, editAction: this.editProduct, deleteAction: this.deleteRelatedCollection }));
    };
    return SamplesList;
}(React.Component));
// @ts-ignore
export default withRouter(SamplesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Samples/SamplesList/SamplesList.tsx
// module id = 451
// module chunks = 0